module.exports = __webpack_public_path__ + "img/narikei.7265fa87.png";